// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ot0tRtqu{width:25%}`, "",{"version":3,"sources":["webpack://./src/fsd/entities/mutualSettlements/ui/MutualSettlements.module.scss"],"names":[],"mappings":"AAAA,UACE,SAAA","sourcesContent":[".filterField {\n  width: 25%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterField": `ot0tRtqu`
};
export default ___CSS_LOADER_EXPORT___;
